import axios from 'axios'
import { getToken } from '@/utils/auth'
export function useFileSystem() {
  function imageUpload(file) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append('name', Math.random().toString().slice(-15))
      formData.append('file', file)
      axios({
        method: 'POST',
        url: process.env.VUE_APP_BASE_API + '/file/upload/image',
        data: formData,
        headers: {
          Authorization: getToken(),
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(res => {
          if (res.data.code === 20000) {
            resolve(res.data.data)
          }
        })
        .catch(() => {
          reject()
        })
    })
  }
  return {
    imageUpload
  }
}
